import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { OverviewAction } from 'components';
import en from '../../../../international/translations/en';
import config from '../../../../config';

export default class InfoCard extends Component {

  static propTypes = {
    subscription: PropTypes.object.isRequired,
    buttonType: PropTypes.string,
    href: PropTypes.string,
    overview: PropTypes.object,
    renewHandler: PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.trackClick = this.trackClick.bind(this);
  }

  componentWillMount() {
    this.vip = this.props.subscription.subscriptions[this.props.brand].length ?
      this.props.subscription.subscriptions[this.props.brand][0].type === 'vip' :
      false;
    this.entitlement = this.props.subscription.subscriptions[this.props.brand].length ?
      this.props.subscription.subscriptions[this.props.brand][0].entitlement :
      'free';
    this.expiring = this.props.subscription.subscriptions[this.props.brand].length ?
      this.props.subscription.subscriptions[this.props.brand][0].expiring :
      false;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.subscription !== nextProps.subscription) {
      this.entitlement = nextProps.subscription.subscriptions[nextProps.brand].length ?
        nextProps.subscription.subscriptions[nextProps.brand][0].entitlement :
        'free';
      this.expiring = nextProps.subscription.subscriptions[nextProps.brand].length ?
        nextProps.subscription.subscriptions[nextProps.brand][0].expiring :
        false;
    }
  }

  getHref = () => {
    let href;
    if (this.entitlement.indexOf('premium') > -1 || this.entitlement.indexOf('vip') > -1) {
      href = en.subscription.goPremium[this.props.brand].benefitsLink;
    } else {
      href = `${config.accountLinkProtocol}${this.props.brandName[this.props.brand]}.com${config.selectPlanRedirect}`;
    }
    return href;
  }

  trackClick = () => {
    window.analytics.track(
      `Clicked Subscribe CTA`,
      {
        ctaLocation: 'account-overview brand card',
        brandSelected: this.props.brand
      }
    );
  }

  render() {
    const { subscription, brand, overview } = this.props;
    if (this.vip) {
      this.theme = 'vip';
    } else if (this.expiring) {
      this.theme = 'expiring';
    } else if (this.entitlement.indexOf('premium') > -1) {
      this.theme = 'premium';
    } else {
      this.theme = 'free';
    }

    const text = en.account.overview.info_card[this.theme];
    const href = this.getHref();

    return (
      <div className={`info__card--${brand}`}>
        <div className="info__card">
          <div>
            <h5 className="info__card__title">{text.title}</h5>
          </div>
          <div className="info__card__message__container">
            <p className="info__card__message__container__message">{text.message[brand]}</p>
            <div className="info__card__link">
              {(() => {
                if (this.theme === 'expiring' && subscription.subscriptions[brand][0].type === 'stripe') {
                  return (
                    <OverviewAction
                      onClickHandler={() => this.props.renewHandler(subscription.subscriptions[brand][0].stripePlanId)}
                      theme={this.theme}
                      isSubmitting={overview.isRenewing}
                      isSubmittingSuccess={overview.isRenewingSuccess}
                      isSubmittingError={overview.isRenewingError}>
                      {text.link_text}
                    </OverviewAction>
                  );
                } else if (this.theme === 'premium' || this.theme === 'vip') {
                  return (
                    <a
                      className="info__card__link__premium"
                      href={href}
                      target="_blank"
                    >
                      {text.link_text}
                    </a>
                  );
                }
                return (
                  <a
                    className="info__card__link__free"
                    onClick={this.trackClick}
                    target="_blank"
                    href={href}>
                    {text.link_text}
                  </a>
                );
              })()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
